<div class="modal-body vtr-modal-update-change-log" tabindex="-1" #logModal>
	<h1>{{'systemUpdates.readMore' | translate}}</h1>
	<div class="log-content" id="updateLogContent">
		<pre [innerHTML]="articleBody" #logContent></pre>
	</div>
	<div role="button" class="close-btn"
		tabindex="0"
		aria-label="close"
		(keydown.enter)="closeModal()"
		(click)="closeModal()">
		<img [src]=" 'assets/icons/Close.svg' | svgInline | async" alt="" srcset=""/>
	</div>
</div>
